// extracted by mini-css-extract-plugin
module.exports = {"stats":"Numbers_stats__mkShP"};